import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupFestiveSaleComponent } from './popup-festive-sale.component';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [PopupFestiveSaleComponent],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports:[PopupFestiveSaleComponent]
})
export class PopupFestiveSaleModule { }
